export class RandomBag {
    items: any[]
    pool:any [] = []

    constructor(...sounds:any []) {
        this.items = sounds
    }

    getNext() {
        if (this.pool.length == 0)
            this.pool = [...this.items]

        const id = Math.floor(Math.random() * this.pool.length)
        const item = this.pool[id]
        this.pool.splice(id, 1)
        return item;
    }
}